"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var receive_1 = __importDefault(require("./receive"));
var send_1 = __importDefault(require("./send"));
exports.default = (function (virtual) { return ({
    receive: receive_1.default(virtual),
    send: send_1.default(virtual)
}); });



// WEBPACK FOOTER //
// ./src/actions/index.ts